import PageLayout from "@/components/layout/PageLayout";
import ExplorePoolsListener from "@nitro-ape/shared/features/explore/listeners/ExplorePoolsListener";
import { createFileRoute } from "@tanstack/react-router";
import ExploreTable from "./-components/ExploreTable";
import ExploreTableFilters from "./-components/ExploreTableFilters";
import { ExploreFiltersProvider } from "./-providers/explore-filters-provider";
import { translateBrand } from "@/lib/i18n";
import { BrandMessageIds } from "@nitro-ape/shared/lib/brand-config";
import { Chain } from "@nitro-ape/shared/models/enums/chain";
import { useState } from "react";
import ExploreChainSelector, {
  type ExploreChain,
} from "./-components/ExploreChainSelector";
import MonacoExploreTable from "./-components/MonacoExploreTable";

export const Route = createFileRoute("/_main/explore/")({
  head: () => ({
    meta: [
      {
        title: translateBrand(BrandMessageIds.metaTitleExplore),
      },
    ],
  }),
  component: ExplorePage,
});

function ExplorePage() {
  const [exploreChain, setExploreChain] = useState<ExploreChain>(
    Chain.monaco_spot,
  );

  const isMonaco = exploreChain === Chain.monaco_spot;

  return (
    <PageLayout>
      <div className="flex h-full max-h-full w-full flex-col gap-1.5">
        <div className="flex flex-col justify-between gap-2 md:flex-row md:items-center">
          <div className="bg-card w-max rounded-2xl p-1">
            <ExploreChainSelector
              selected={exploreChain}
              onSelect={setExploreChain}
            />
          </div>
        </div>

        {isMonaco ? (
          <MonacoExploreTable />
        ) : (
          <ExploreFiltersProvider>
            <ExplorePoolsListener>
              <ExploreTableFilters />
              <ExploreTable />
            </ExplorePoolsListener>
          </ExploreFiltersProvider>
        )}
      </div>
    </PageLayout>
  );
}
